import * as React from 'react';
import { token } from './theme';

/*
 * Text — typography primitive. Sizes/colors come from tokens; weights are plain
 * numbers (they aren't themed). Replaces the old text.tsx / text-container.tsx.
 */

type Variant = 'title' | 'heading' | 'body' | 'label' | 'value' | 'muted';

const VARIANTS: Record<Variant, React.CSSProperties> = {
  title: { fontSize: token('font-size-2xl'), fontWeight: 700 },
  heading: { fontSize: token('font-size-xl'), fontWeight: 700 },
  body: { fontSize: token('font-size-md'), fontWeight: 400 },
  label: {
    fontSize: token('font-size-xs'),
    fontWeight: 600,
    letterSpacing: token('letter-spacing-wide'),
    textTransform: 'uppercase',
    color: token('color-muted'),
  },
  value: { fontSize: token('font-size-lg'), fontWeight: 700 },
  muted: { fontSize: token('font-size-sm'), color: token('color-muted') },
};

interface TextProps extends React.HTMLAttributes<HTMLElement> {
  variant?: Variant;
  color?: string;
  as?: keyof JSX.IntrinsicElements;
}

export const Text: React.FC<TextProps> = ({
  variant = 'body',
  color,
  as = 'span',
  style,
  children,
  ...rest
}) => {
  const Tag = as as any;
  return (
    <Tag
      style={{
        fontFamily: token('font-sans'),
        color: color ?? token('color-text'),
        margin: 0,
        ...VARIANTS[variant],
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Text;
